<script setup lang="ts">
const props = defineProps<{
  value: boolean;
  disabled?: boolean;
  loading?: boolean;
}>();

const emit = defineEmits<{
  (e: 'toggle'): void;
}>();

const handleToggle = () => {
  if (props.disabled) {
    return;
  }
  emit('toggle');
};
</script>

<template>
  <label
    class="checkbox"
    :class="{ disabled: disabled }"
    @click.prevent="handleToggle"
  >
    <UiCheckbox2 :value="value" :disabled="disabled" :loading="loading" />

    <div>
      <slot />
    </div>
  </label>
</template>

<style lang="scss" scoped>
label.checkbox {
  display: flex;
  align-items: center;
  margin-bottom: var(--space-16);
  cursor: pointer;

  &.disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }
}
</style>
